import React, { Fragment, useEffect, useState } from 'react'
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { InputText } from "primereact/inputtext";
import Select from 'react-select';




export const ReportBalance = (props) => {

	const {
		filter, setFilters, commercialLines, listOfClients, reportBalance, loading, handleGetReportBalance, exportToExcelBalance, globalFilter, setGlobalFilter, number_format,
		expandedRows, setExpandedRows, rowExpansionTemplate

	} = props;


	// ? CONFIGURATION DATATABLE
	const headerStyle =
	{
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "11px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle =
	{
		fontSize: "11px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",
	};

	const centerStyle =
	{
		...cellStyle,
		textAlign: "center",
		zIndex: 2, border: "1px solid #cccccc9c",
		borderCollapse: "collapse"
	};

	// ? RENDER ROWS
	const renderRows = () => {
		return reportBalance?.flatMap((client) =>
			client?.reportBalanceList?.map((_order, index) => {
				const serie = _order.serie ?? '';
				const folio = _order.folio ?? '';
				return {
					...client,
					..._order,
					rowIndex: index + 1,
					serieFolio: `${serie} ${folio}`
				};
			})
		);
	};


	const rows = renderRows();

	const fechaFolioTag = (rowData) => {
		const serie = rowData.serie ?? '';
		const folio = rowData.folio ?? '';
		const status = rowData.statusInvoice ?? 0;
		return (
			<Tag
				className="mr-2"
				severity={status === "Timbrado" ? "secondary" : "warning"}
				value={`${serie} ${folio}`}
				style={{
					fontSize: "0.7rem",
					padding: "2px 6px",
					maxWidth: "120px",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				}}
			/>
		);
	};


	const filteredRows = rows.filter((r) => {
		if (!globalFilter) return true;
		const filterText = globalFilter.toLowerCase();
		return (
			(r.clientName ?? "").toLowerCase().includes(filterText) ||
			(r.clientCode ?? "").toLowerCase().includes(filterText) ||
			(r.clientCommercialLine ?? "").toLowerCase().includes(filterText) ||
			(r.serieFolio ?? "").toLowerCase().includes(filterText)
		);
	});

	const totalSum = filteredRows.reduce((acc, r) => acc + (r.total ?? 0), 0);
	const creditNotesSum = filteredRows.reduce((acc, r) => acc + (r.totalOfCreditNotes ?? 0), 0);
	const paidSum = filteredRows.reduce((acc, r) => acc + (r.totalPaid ?? 0), 0);
	const pendingSum = filteredRows.reduce((acc, r) => acc + (r.totalPending ?? 0), 0);

	const footerStyle =
	{
		backgroundColor: '#000',
		color: '#fff',
		fontWeight: 'bold',
		textAlign: 'center',
		fontSize: '0.75rem',
		padding: '4px',
	};



	return (
		<>
			<Col sm="12" md="12" lg="12" className='p-l-0 p-r-0' >
				<CardBody className='p-1' >
					<DataTable
						value={filteredRows}
						paginator
						loading={loading}
						rows={8}
						expandedRows={expandedRows}
						onRowToggle={(e) => setExpandedRows(e.data)}
						rowExpansionTemplate={rowExpansionTemplate}
						rowsPerPageOptions={[8, 16, 50, 100, 200, 300]}
						className="data-table"
						responsiveLayout="scroll"
						emptyMessage="No hay coincidencias con la búsqueda."
						globalFilter={globalFilter}
						stripedRows
						globalFilterFields={['clientCode', 'clientName', 'clientCommercialLine', 'serieFolio']}
					>
						<Column
							header="#"
							body={(_, { rowIndex }) => rowIndex + 1}
							headerStyle={headerStyle}
							style={centerStyle}
							footer=""
						/>

						<Column
							sortable
							field="clientCode"
							header="Código"
							headerStyle={headerStyle}
							style={centerStyle}
							footer=""
						/>

						<Column
							sortable
							field="clientName"
							header="Cliente"
							headerStyle={headerStyle}
							style={centerStyle}
							footer=""
						/>

						<Column
							sortable
							field="clientCommercialLine"
							header="Razón social"
							headerStyle={headerStyle}
							style={centerStyle}
							footer=""
						/>

						<Column
							header="Serie/Folio"
							body={(row) => fechaFolioTag(row)}
							headerStyle={headerStyle}
							style={centerStyle}
							footer=""
						/>

						<Column
							sortable
							field="dateIssuing"
							header="Fecha de Emisión de la factura"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => {
								const date = rowData.dateIssuing;
								let bgColor = "#ffffff";

								if (date) {
									const month = parseInt(date.split("-")[1]);

									switch (month) {
										case 1: bgColor = "#B3E5FC"; break;
										case 2: bgColor = "#F8BBD0"; break;
										case 3: bgColor = "#FFE0B2"; break;
										case 4: bgColor = "#D1C4E9"; break;
										case 5: bgColor = "#FFCDD2"; break;
										case 6: bgColor = "#C8E6C9"; break;
										case 7: bgColor = "#fdb592"; break;
										case 8: bgColor = "#51bb256e"; break;
										case 9: bgColor = "#BBDEFB"; break;
										case 10: bgColor = "#E1BEE7"; break;
										case 11: bgColor = "#CFD8DC"; break;
										case 12: bgColor = "#B2EBF2"; break;
										default: bgColor = "#ffffff";
									}
								}
								return (
									<span
										style={{
											backgroundColor: bgColor,
											padding: "4px 8px",
											borderRadius: "4px",
											display: "inline-block",
											width: "100%",
											textAlign: "center",

										}}
									>
										{date}
									</span>
								);
							}}
							footer="Totales:"
							footerStyle={footerStyle}
						/>
						<Column
							sortable
							field="total"
							header="Monto facturado"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => `$${number_format(rowData.total ?? 0, 2)}`}
							footer={`$${number_format(totalSum, 2)}`}
							footerStyle={footerStyle}
						/>

						<Column
							sortable
							field="totalOfCreditNotes"
							header="Nota Crédito"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => `$${number_format(rowData.totalOfCreditNotes ?? 0, 2)}`}
							footer={`$${number_format(creditNotesSum, 2)}`}
							footerStyle={footerStyle}
						/>

						<Column
							sortable
							field="totalPaid"
							header="Monto Pagado"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => `$${number_format(rowData.totalPaid ?? 0, 2)}`}
							footer={`$${number_format(paidSum, 2)}`}
							footerStyle={footerStyle}
						/>

						<Column
							sortable
							field="totalPending"
							header="Monto Pendiente"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => `$${number_format(rowData.totalPending ?? 0, 2)}`}
							footer={`$${number_format(pendingSum, 2)}`}
							footerStyle={footerStyle}
						/>

						<Column
							sortable
							field="creditDays"
							header="Días Crédito"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => rowData.creditDays ?? '0'}
							footer=""
						/>

						<Column
							sortable
							field="dateOfPosiblePayment"
							header="Fecha Limite Pago"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => rowData.dateOfPosiblePayment ?? '---'}
							footer=""
						/>

						<Column
							sortable
							field="dateOfPayments"
							header="Fecha Pago"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => rowData.dateOfPayments ?? '---'}
							footer=""
						/>

						<Column
							sortable
							field="statusOfTrackingPayment"
							header="Estatus"
							headerStyle={headerStyle}
							style={centerStyle}
							body={(rowData) => (
								<Label
									type="text"
									className={`f-w-600 badge badge-${rowData.statusOfPayment === "Pagado" ? 'success' : 'warning'}`}
								>
									{rowData.statusOfPayment === "Pagado" ? 'Pagado' : rowData.statusOfTrackingPayment}
								</Label>
							)}
							footer=""
						/>
					</DataTable>
				</CardBody>
			</Col >
		</>
	)
}
